module.exports = __webpack_public_path__ + "media/images/story/top/step4_image-b941c2c8671e689a5171034d9cbdc679.png";